import { DatepickerInterval, DatepickerMonth, DatepickerPeriod } from '../datepicker-range-advanced.interfaces';


export function getDatepickerMonthPeriods(start: Date, end: Date): DatepickerPeriod[] {
  const datepickerPeriods: DatepickerPeriod[] = [];
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();

  for (let year = startYear; year <= endYear; year++) {
    const months = [];
    const startMonth = year === startYear ? start.getMonth() + 1 : 1;
    const endMonth = year === endYear ? end.getMonth() + 1 : 12;

    for (let month = startMonth; month <= endMonth; month++) {
      const datepickerMonth: DatepickerMonth = {
        id: `${year}-${month.toString().padStart(2, '0')}`,
        year,
        month,
      };
      months.push(datepickerMonth);
    }

    datepickerPeriods.push({ year, months });
  }

  return datepickerPeriods;
}

export function getSelectionInterval(startDateStr: string, endDateStr: string, minDate: Date, maxDate: Date): DatepickerInterval {
  if (new Date(startDateStr) > new Date(endDateStr)) {
    [startDateStr, endDateStr] = [endDateStr, startDateStr];
  }

  const startDate: Date = getStartDate(startDateStr, minDate);
  const endDate: Date = getEndDate(endDateStr, maxDate);

  return { startDate, endDate };
}

export function getStartDate(yearMonthStart: string, minDate: Date): Date {
  const [year, month] = yearMonthStart.split('-').map(Number);

  const startDate = new Date(year, month - 1, 1);

  return startDate < minDate ? minDate : startDate;
}

export function getEndDate(yearMonthEnd: string, maxDate: Date): Date {
  const [year, month] = yearMonthEnd.split('-').map(Number);

  const endDate = new Date(year, month, 1);
  endDate.setDate(endDate.getDate() - 1);

  return endDate > maxDate ? maxDate : endDate;
}

export function getLastDayOfMonth(yearMonth: string): number {
  const [year, month] = yearMonth.split('-').map(Number);

  const nextMonth: Date = new Date(year, month, 1);
  nextMonth.setDate(nextMonth.getDate() - 1);

  return nextMonth.getDate();
}
